import React from 'react';
import { withRouter } from 'react-router-dom';

class BackButton extends React.Component {
  render() {
    const path = this.getRedirectTo().pathname
      ? this.getRedirectTo().pathname.split('/')[2]
      : 'Back';
    const computedPath = path === 'services' ? 'Services Calendar' : path;
    return (
      <p
        onClick={this.handleClick}
        className="cms__back-link a--blue --capitalize"
      >
        {computedPath}
      </p>
    );
  }

  handleClick = () => {
    const redirect_to = this.getRedirectTo();
    if (redirect_to.pathname) this.props.history.push(redirect_to);
    else this.props.history.goBack();
  };

  getRedirectTo = () => {
    const pathname = this.props.defaultUrl || '';
    const payload = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        payload.pathname = redirect_url;
      }

      if (redirect_payload) payload.state = { ...redirect_payload };
    }
    return payload;
  };
}

export default withRouter(BackButton);



// WEBPACK FOOTER //
// ./src/components/shared/BackButton.js